import { useState as H, useLayoutEffect as te, useEffect as j, useRef as W, useMemo as re } from "react";
import { c as p, g as ie } from "./_commonjsHelpers-B4e78b8K.js";
var R, D;
function oe() {
  if (D) return R;
  D = 1;
  var n = "Expected a function", t = NaN, a = "[object Symbol]", c = /^\s+|\s+$/g, f = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, u = /^0o[0-7]+$/i, i = parseInt, P = typeof p == "object" && p && p.Object === Object && p, G = typeof self == "object" && self && self.Object === Object && self, N = P || G || Function("return this")(), U = Object.prototype, V = U.toString, Q = Math.max, X = Math.min, I = function() {
    return N.Date.now();
  };
  function J(e, s, l) {
    var b, v, S, g, d, h, w = 0, C = !1, y = !1, T = !0;
    if (typeof e != "function")
      throw new TypeError(n);
    s = z(s) || 0, O(l) && (C = !!l.leading, y = "maxWait" in l, S = y ? Q(z(l.maxWait) || 0, s) : S, T = "trailing" in l ? !!l.trailing : T);
    function x(o) {
      var m = b, E = v;
      return b = v = void 0, w = o, g = e.apply(E, m), g;
    }
    function Z(o) {
      return w = o, d = setTimeout(L, s), C ? x(o) : g;
    }
    function q(o) {
      var m = o - h, E = o - w, A = s - m;
      return y ? X(A, S - E) : A;
    }
    function _(o) {
      var m = o - h, E = o - w;
      return h === void 0 || m >= s || m < 0 || y && E >= S;
    }
    function L() {
      var o = I();
      if (_(o))
        return F(o);
      d = setTimeout(L, q(o));
    }
    function F(o) {
      return d = void 0, T && b ? x(o) : (b = v = void 0, g);
    }
    function ee() {
      d !== void 0 && clearTimeout(d), w = 0, b = h = v = d = void 0;
    }
    function ne() {
      return d === void 0 ? g : F(I());
    }
    function M() {
      var o = I(), m = _(o);
      if (b = arguments, v = this, h = o, m) {
        if (d === void 0)
          return Z(h);
        if (y)
          return d = setTimeout(L, s), x(h);
      }
      return d === void 0 && (d = setTimeout(L, s)), g;
    }
    return M.cancel = ee, M.flush = ne, M;
  }
  function O(e) {
    var s = typeof e;
    return !!e && (s == "object" || s == "function");
  }
  function K(e) {
    return !!e && typeof e == "object";
  }
  function Y(e) {
    return typeof e == "symbol" || K(e) && V.call(e) == a;
  }
  function z(e) {
    if (typeof e == "number")
      return e;
    if (Y(e))
      return t;
    if (O(e)) {
      var s = typeof e.valueOf == "function" ? e.valueOf() : e;
      e = O(s) ? s + "" : s;
    }
    if (typeof e != "string")
      return e === 0 ? e : +e;
    e = e.replace(c, "");
    var l = r.test(e);
    return l || u.test(e) ? i(e.slice(2), l ? 2 : 8) : f.test(e) ? t : +e;
  }
  return R = J, R;
}
var ce = oe();
const B = /* @__PURE__ */ ie(ce);
var k = typeof window < "u" ? te : j;
function $(n, t, a, c) {
  const f = W(t);
  k(() => {
    f.current = t;
  }, [t]), j(() => {
    const r = window;
    if (!(r && r.addEventListener))
      return;
    const u = (i) => {
      f.current(i);
    };
    return r.addEventListener(n, u, c), () => {
      r.removeEventListener(n, u, c);
    };
  }, [n, a, c]);
}
var ue = typeof window > "u";
function me(n, {
  defaultValue: t = !1,
  initializeWithValue: a = !0
} = {}) {
  const c = (i) => ue ? t : window.matchMedia(i).matches, [f, r] = H(() => a ? c(n) : t);
  function u() {
    r(c(n));
  }
  return k(() => {
    const i = window.matchMedia(n);
    return u(), i.addListener ? i.addListener(u) : i.addEventListener("change", u), () => {
      i.removeListener ? i.removeListener(u) : i.removeEventListener("change", u);
    };
  }, [n]), f;
}
function se(n) {
  const t = W(n);
  t.current = n, j(
    () => () => {
      t.current();
    },
    []
  );
}
function ae(n, t = 500, a) {
  const c = W();
  se(() => {
    c.current && c.current.cancel();
  });
  const f = re(() => {
    const r = B(n, t, a), u = (...i) => r(...i);
    return u.cancel = () => {
      r.cancel();
    }, u.isPending = () => !!c.current, u.flush = () => r.flush(), u;
  }, [n, t, a]);
  return j(() => {
    c.current = B(n, t, a);
  }, [n, t, a]), f;
}
function he(n, t, a = "mousedown", c = {}) {
  $(
    a,
    (f) => {
      const r = f.target;
      if (!r || !r.isConnected)
        return;
      (Array.isArray(n) ? n.filter((i) => !!i.current).every((i) => i.current && !i.current.contains(r)) : n.current && !n.current.contains(r)) && t(f);
    },
    void 0,
    c
  );
}
var fe = typeof window > "u";
function be(n = {}) {
  let { initializeWithValue: t = !0 } = n;
  fe && (t = !1);
  const [a, c] = H(() => t ? {
    width: window.innerWidth,
    height: window.innerHeight
  } : {
    width: void 0,
    height: void 0
  }), f = ae(
    c,
    n.debounceDelay
  );
  function r() {
    (n.debounceDelay ? f : c)({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  return $("resize", r), k(() => {
    r();
  }, []), a;
}
export {
  be as a,
  he as b,
  me as u
};
